import Pipe from './Pipe';

export default class PCPipe extends Pipe {
  minVelocity: number;

  maxVelocity: number;

  colour: string;

  // Class-field semantics have always reset Pipe's friction after super(); keep that explicit.
  friction?: number = undefined;

  constructor(
    pipeName: string,
    pipeId: string,
    clss: string,
    insideDiameter: number,
    pressureRating: number,
    colour: string,
    minVelocity?: number,
    maxVelocity?: number,
    material?: string,
    minimumPressure?: number,
    startingThickness?: number,
    minimumThickness?: number,
    ) {
    super(
      pipeName,
      pipeId,
      clss,
      insideDiameter,
      pressureRating,
      material,
      minimumPressure,
      startingThickness,
      minimumThickness,
    );
    this.minVelocity = minVelocity || 0.7;
    this.maxVelocity = maxVelocity || 2.0;
    this.colour = colour;
  }
}
